import React from 'react';
import {concatenate} from "services/string";

export enum Size {SMALL, LARGE}

export enum Color {BRAND, BLUE, GREEN, YELLOW, RED, GRAY}

type Props = {
    size: Size
    color: Color
    text: string
    ping: boolean
}

const badgeSizeClasses: Record<Size, string> = {
    [Size.SMALL]: 'px-2.5 py-0.5 text-xs',
    [Size.LARGE]: 'px-3 py-0.5 text-sm',
}

const dotSizeClasses: Record<Size, string> = {
    [Size.SMALL]: '-ml-0.5 mr-1.5',
    [Size.LARGE]: '-ml-1 mr-1.5',
}

const badgeColorClasses: Record<Color, string> = {
    [Color.BRAND]: 'bg-brand/20 bg-gradient-white-overlay text-brand',
    [Color.BLUE]: 'bg-blue-100 text-blue-800',
    [Color.GREEN]: 'bg-green-100 text-green-800',
    [Color.YELLOW]: 'bg-yellow-100 text-yellow-800',
    [Color.RED]: 'bg-red-100 text-red-800',
    [Color.GRAY]: 'bg-gray-100 text-gray-800',
}

const dotColorClasses: Record<Color, string> = {
    [Color.BRAND]: 'text-brand/60',
    [Color.BLUE]: 'text-blue-400',
    [Color.GREEN]: 'text-green-400',
    [Color.YELLOW]: 'text-yellow-400',
    [Color.RED]: 'text-red-400',
    [Color.GRAY]: 'text-gray-400',
}

function DotBadge(props: Props) {
    const {size, color, text, ping} = props

    return (
        <span className={concatenate(badgeSizeClasses[size], badgeColorClasses[color], 'inline-flex items-center rounded-md font-medium')}>
            {/* Dot */}
            <span className={concatenate(dotSizeClasses[size])}>
                {ping? <svg className={concatenate(dotColorClasses[color], 'h-2 w-2 absolute animate-ping')} fill="currentColor" viewBox="0 0 8 8">
                    <circle cx={4} cy={4} r={3} />
                </svg> : null}
                <svg className={concatenate(dotColorClasses[color], 'h-2 w-2')} fill="currentColor" viewBox="0 0 8 8">
                    <circle cx={4} cy={4} r={3} />
                </svg>
            </span>

            {/* Text */}
            {text}
        </span>
    );
}

DotBadge.sizes = Size
DotBadge.colors = Color

DotBadge.defaultProps = {
    size: Size.SMALL,
    color: Color.GRAY,
    ping: false
}

export default DotBadge;